export default __webpack_public_path__ + "static/media/SndLowerSCurveAround.e0598527.mp3";